import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import * as d3 from 'd3';
import { Container } from '@angular/compiler/src/i18n/i18n_ast';
declare var $: any;
@Component({
    selector: 'app-trend-chart',
    templateUrl: './trend-chart.component.html'
})
export class TrendChartComponent implements OnInit {
    @Input() pageNumber: any;
    @Input() GraphData: any;
    //@Input() chartContainer: any;
    @Input() categoryId: any;
    constructor() { }
    ngOnInit(): void {

    }

    ngAfterViewInit() {
        this.LoadTrendCharts('#trend' + this.categoryId, this.categoryId, this.GraphData, this.pageNumber = null);
    }
    LoadTrendCharts(chartContainer, categoryId, amoTileProperties, pageNumber = null) {

        d3.select(chartContainer).html("");

        var categoryData = amoTileProperties.filter((d) => d.CategoryId == categoryId);

        if (categoryData == null && categoryData.length == 0) {
            return;
        }
        var years = [];
        var mixedData = [];
        var inputData = [];
        var pageCount = 0;
        //var monthData = ["2017-Dec", "2018-Jan", "2018-Feb", "2018-Mar", "2018-Apr", "2018-May", "2018-Jun", "2018-Jul", "2018-Aug", "2018-Sep", "2018-Oct", "2018-Nov", "2018-Dec"]; // categoryData[0].TrendDataDate;
        //var data = [6, 31, 224, 254, 249, 12, 181, 229, 205, 260, 213, 199, 245]; // categoryData[0].TrendData;
        var monthData = categoryData[0].TrendDataDate;
        var data = categoryData[0].TrendData;
        if(monthData!=null){
        monthData.forEach(function (key, index) {
            years.push(key.split('-')[0]);
            mixedData.push({ "month": key.split('-')[1], "year": key.split('-')[0], "value": data[index] });
        });
    }
        years = [...new Set(years)];
        var valuesPerPage = 6;
        var self = this;
        years.forEach(function (year, index) {
            if (inputData.length != 0) {
                pageCount = inputData[inputData.length - 1].page;
            }
            inputData = self.GetYearData(mixedData, year, inputData, valuesPerPage, pageCount);
        });
        if (pageNumber == null){ //&& inputData.filter(x => (x.value == 0 && x.page == 1)).length == valuesPerPage) {
            if (inputData.length != 0) {
            let firstElementPage = inputData.find( x => x.value > 0).page;
            pageNumber = firstElementPage;
            }
        }
        if(inputData.length!=0){
        var totalPagenumber = inputData[inputData.length - 1].page;
        }
        $('#trendChart_' + categoryId).data('totalpage', totalPagenumber);
        //$('#trend_left_' + categoryId).data('totalpage', totalPagenumber);
        //$('#trend_right_' + categoryId).data('totalpage', totalPagenumber);
        $('#trend_left_' + categoryId).show();
        $('#trend_right_' + categoryId).show();
        if (totalPagenumber == 1) {
            $('#trend_left_' + categoryId).hide();
            $('#trend_right_' + categoryId).hide();
        }
        else if (pageNumber == null) {
            if(inputData.length !=0){
            inputData = inputData.filter(x => x.page == 1);
            }
            $('#trend_left_' + categoryId).css('cursor', 'default');
            $('#trend_left_' + categoryId).addClass('disabled');
            $('#trend_left_' + categoryId).css('pointer-events', 'none');
            $('#trend_left_' + categoryId).prop('title', 'Disabled');
            $('#trend_right_' + categoryId).data('nextpage', 2);
            $('#trend_right_' + categoryId).prop('title', 'Next');
            $('#trend_right_' + categoryId).removeClass('disabled');
            $('#trend_right_' + categoryId).css('cursor', 'pointer');
            $('#trend_right_' + categoryId).css('pointer-events', 'auto');
        }
        else {
            if(inputData.length != 0){
            inputData = inputData.filter(x => x.page == pageNumber);
            }
            if (pageNumber == 1) {
                $('#trend_left_' + categoryId).css('cursor', 'default');
                $('#trend_left_' + categoryId).addClass('disabled');
                $('#trend_left_' + categoryId).css('pointer-events', 'none');
                $('#trend_left_' + categoryId).prop('title', 'Disabled');
                $('#trend_right_' + categoryId).data('nextpage', 2);
                $('#trend_right_' + categoryId).prop('title', 'Next');
                $('#trend_right_' + categoryId).removeClass('disabled');
                $('#trend_right_' + categoryId).css('cursor', 'pointer');
                $('#trend_right_' + categoryId).css('pointer-events', 'auto');
            }
            else if (pageNumber + 1 > totalPagenumber) {
                $('#trend_right_' + categoryId).css('cursor', 'default');
                $('#trend_right_' + categoryId).css('pointer-events', 'none');
                $('#trend_right_' + categoryId).addClass('disabled');
                $('#trend_right_' + categoryId).prop('title', 'Disabled');
                $('#trend_left_' + categoryId).data('previouspage', pageNumber - 1);
                $('#trend_left_' + categoryId).prop('title', 'Previous');
                $('#trend_left_' + categoryId).removeClass('disabled');
                $('#trend_left_' + categoryId).css('cursor', 'pointer');
                $('#trend_left_' + categoryId).css('pointer-events', 'auto');
            }
            else {
                $('#trend_left_' + categoryId).removeClass('disabled');
                $('#trend_right_' + categoryId).removeClass('disabled');
                $('#trend_left_' + categoryId).prop('title', 'Previous');
                $('#trend_right_' + categoryId).prop('title', 'Next');
                $('#trend_left_' + categoryId).css('pointer-events', 'auto');
                $('#trend_right_' + categoryId).css('pointer-events', 'auto');
                $('#trend_left_' + categoryId).data('previouspage', pageNumber - 1);
                $('#trend_left_' + categoryId).css('cursor', 'pointer');
                $('#trend_right_' + categoryId).data('nextpage', pageNumber + 1);
                $('#trend_right_' + categoryId).css('cursor', 'pointer');
            }
        }
        if(inputData.length != 0){
        $('#trendTitle_' + categoryId).text(inputData[inputData.length - 1].date.split('-')[0]);
        }
        var opacity = .9;
        var margin = { top: 25, right: 5, bottom: 0, left: 5 },
            width = document.getElementById('trend' + categoryId).clientWidth - margin.left - margin.right,
            //width = 65 - margin.left - margin.right,
            height = 65 - margin.top - margin.bottom;

        var svg = d3.select(chartContainer)
            .append('svg').attr('id', 'svg_' + chartContainer)
            //.attr('svg_' + heatMapData.chartContainerName)
            .classed("resizableSVG", true)
            .attr('xmlns', "http://www.w3.org/2000/svg")
            .attr('viewBox', "0 0 " + (width + margin.left + margin.right) + " " + (height + margin.top + margin.bottom) + "")
            .attr('preserveAspectRatio', 'xMidYMid meet')
            //.classed("svg-content", true)
            //.attr("width", width + margin.left + margin.right)
            //.attr("height", height + margin.top + margin.bottom)
            .style('overflow', 'visible')
            .style('margin-left', margin.left)
            .style('margin-right', margin.right);

        //Create group element inside svg element to draw chart
        var chart = svg.append("g")
            .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")"
            )
            .attr('fill', 'url(#areaGradient_' + categoryId + ')');
        var svgDef = chart.append('defs')
            .append("linearGradient")
            .attr("id", "areaGradient_" + categoryId)
            .attr("x1", 0).attr("y1", 0)
            .attr("x2", 0).attr("y2", 1)
            .selectAll("stop")
            .data([
                { offset: 0, color: "#2d9ebf" }, //"#135970" 
                { offset: 1, color: "#ffffff" }, //#e2edf2 //"#2e1413"
            ])
            .enter().append("stop")
            .attr("offset", (d) => d.offset)
            .style("stop-color", (d) => d.color)
            .style("stop-opacity", 1);
        // parse the date / time
        //var parseDate = d3.timeFormat("%Y/%m/%d");
        // parse the date / time
        var parseTime = d3.timeParse("%Y-%b");

        //var date = parseTime(splineData[0].XAxis);

        var maxData = d3.max(inputData, function (d) {
            return d.value;
        });
        var yScale = d3.scaleLinear().range([height, 0])
        if (maxData > 0) {
            yScale.domain([0, d3.max(inputData, function (d) {
                return d.value;
            })]);
        }
        else
            yScale.domain([0, 0.5]);

        var xScale = d3.scaleTime().domain(d3.extent(inputData, function (d) { return parseTime(d.date); })).range([0, width]);

        chart.append('g')
            .attr("transform", "translate(0," + height + ")")
            .attr("class", "xaxis")
            .call(d3.axisBottom(xScale)
                //.tickSize(-height)
                ////.tickPadding(5)
                ////.tickSize(10, 9, 0)
                .tickFormat(d3.timeFormat("%b"))
                .tickValues(inputData.map(function (d) { return parseTime(d.date); }))
            )
            .selectAll("text")
            .attr('fill', '#015b63')
            .style('font-size', '9px')
            .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
            .style('white-space', 'nowrap')
            .style('cursor', 'default')
            .attr('y', '10')
            .attr('dy', '0.71em')
            .attr('x', '-10')
            .style('text-anchor', 'start')
        //.attr('transform', d => 'rotate(-45)')

        chart.select('.xaxis').selectAll('line')
            .style('display', 'none');
        //    .attr('stroke', '#000000')
        //    .attr('opacity', 0.08)
        chart.select('.xaxis')
            .select('.domain')
            .style('opacity', 0);
        //////Tooltip
        //const tooltip = d3.select(chartContainer)
        //    .append("div")
        //    .attr("class", "tooltip")
        //    .style("opacity", 0);

        //// define the line for actual value
        var line1 = d3.line()
            .x(function (d) {
                return xScale(parseTime(d.date));
            }) // set the x values for the line generator
            .y(function (d) {
                //console.log(d.value)
                return yScale(d.value);
                // set the y values for the line generator 
            });
        var line2 = d3.line()
            .x(function (d) {
                return xScale(parseTime(d.date));
            }) // set the x values for the line generator
            .y(function (d) {
                return yScale(0);
                // set the y values for the line generator 
            });
        var area = d3.area()
            .x((d, i) => (xScale(parseTime(d.date))))
            .y0(height)
            .y1((d) => yScale(d.value));

        ////Binds data to the line2 - dummy line instead of axis
        chart.append('g')
            .append("path")
            .datum(inputData)
            //.attr('class', 'line')
            .attr('d', line2)
            .attr('stroke', '#C0C0C0')
            .attr("stroke-width", 2)
            .attr("fill", "none");


        chart.append("path")
            .datum(inputData)
            .attr("d", area)

        chart.selectAll("rect")
            .data(inputData)
            .enter()
            .append("rect")
            .attr("x", (d, i) => {
                return xScale(parseTime(d.date))
            })
            .attr("height", height) //(d, i) => height - heightArray[i])
            .attr("width", 0.05)
            .style('fill', '#000000')
            .style('fill-opacity', 1)
            .attr('stroke', '#000000')
            .attr('stroke-width', '0.05')

        ////Binds data to the line1
        chart.append('g')
            .append("path")
            .datum(inputData)
            //.attr('class', 'line')
            .attr('d', line1)
            .attr('stroke', '#296986')
            .attr("stroke-width", 3)
            .attr("fill", "none");


        //append dots for each data to hover
        var dots = chart
            .selectAll(".trenddot")
            .data(inputData)
            .enter()
            .append('g')
        dots.append("circle") // Uses the enter().append() method
            .attr("class", "trenddot") // Assign a class for styling
            .attr('fill', '#ffffff')
            .attr('stroke', '#296986')
            .attr('opacity', function (d) { return d.value == null ? '0' : '1' })
            //.classed('forecastdot', true)
            .attr("cx", function (d) { if (d.value != null) { return xScale(parseTime(d.date)) } })
            .attr("cy", function (d) { if (d.value != null) { return yScale(d.value) } })
            .attr("r", 4)
            .on("mouseover", function (d, i) {
                $('#trend_left_' + categoryId).hide();
                $('#trend_right_' + categoryId).hide();
                self.mouseHover(chartContainer, this, d.date, d.value, i);
            })
            .on("mousemove", function (d) {
                var transformResult = self.mouseMove(chartContainer, this, height, width);
                d3.select(chartContainer).select("svg").select('.tooltip')
                    .style("opacity", 1)
                    .attr('transform', `translate(${transformResult.x - 30}, ${transformResult.y - 20})`);
                //.attr('transform', 'translate(' + d3.select(this).attr("cx") + ',' + (d3.select(this).attr("cy") - 50) + ')');
            })
            .on("mouseout", function (d, i) {
                if (totalPagenumber != 1) {
                    $('#trend_left_' + categoryId).show();
                    $('#trend_right_' + categoryId).show();
                }
                self.mouseOut(chartContainer, this, opacity, i);
            })
        dots.append("circle") // Uses the enter().append() method
            .attr("class", "trenddot") // Assign a class for styling
            .attr('fill', '#296986')
            .style('pointer-events', 'none')
            .attr('opacity', function (d) { return d.value == null ? '0' : '0.5' })
            .attr('id', (d, i) => { return 'trend_circle_' + i })
            //.classed('forecastdot', true)
            .attr("cx", function (d) { if (d.value != null) { return xScale(parseTime(d.date)) } })
            .attr("cy", function (d) { if (d.value != null) { return yScale(d.value) } })
            .attr("r", 8)
            .style('display', 'none')

        /// Next/Previous functionality
        $('.trendLeft').off().on('click', function () {
            var categoryId = $(this).attr('id').split('_')[2];
            var pageNo = $(this).data("previouspage");
            self.LoadTrendCharts($('#trend' + categoryId)[0], categoryId, self.GraphData, pageNo);
            return true;
        });
        $('.trendRight').off().on('click', function () {
            var categoryId = $(this).attr('id').split('_')[2];
            var pageNo = $(this).data("nextpage");
            self.LoadTrendCharts($('#trend' + categoryId)[0], categoryId, self.GraphData, pageNo);
            return true;
        });
    }
    GetYearData(mixedData, year, inputData, valuesPerPage, pageCount) {
        var allMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var yearData = mixedData.filter((d) => d.year == year);
        //var inputData = [];
        allMonths.forEach((month, index) => {
            if (yearData.filter(x => x.month === month).length == 0)
                inputData.push({ "date": year + "-" + month, "value": 0, "page": (inputData.length % valuesPerPage == 0 ? (pageCount += 1) : pageCount) });
            else
                inputData.push({ "date": year + "-" + month, "value": yearData.filter(x => x.month === month)[0].value, "page": (inputData.length % valuesPerPage == 0 ? (pageCount += 1) : pageCount) });
        })
        return inputData;
    }
    mouseHover(container, pathElement, name, value, i) {
        d3.select(pathElement).style('cursor', 'pointer');
        d3.select(container).select("svg").select('#trend_circle_' + i).style("display", 'block');
        var tooltip = d3.select(container).select("svg")
            .append("g")
            .style("cursor", "pointer")
            .attr("class", "tooltip")
            .style("opacity", 1)
        tooltip.append("rect")
            .attr("width", 90)
            .attr('height', 40)
            .style('fill', '#FFFFFF')
            .style('pointer-events', 'none')
            .style('stroke', this.ConvertRGB2Hex(d3.select(pathElement).style('fill')) == '#ffffff' ? "#296986" : d3.select(pathElement).style('fill'))
            .style('stroke-width', 2)
            .style('fill-opacity', 0.8);
        var textSvg = tooltip.append("text")
            .attr('x', 7)
            .attr('y', 15)
            .style('pointer-events', 'none')
            .style('fill', '#333333')
            .style('font-size', '12px')
            .style('color', '#333333');
        textSvg.append("tspan")
            .style('font-size', '10px')
            .style('pointer-events', 'none')
            .style('font-weight', 'bold')
            .text(name)
        textSvg.append("tspan")
            .attr('x', 7)
            .attr('dy', 15)
            .style('pointer-events', 'none')
            .style('fill', this.ConvertRGB2Hex(d3.select(pathElement).style('fill')) == '#ffffff' ? "#296986" : d3.select(pathElement).style('fill'))
            .html('&#x25cf') //&#9679; //&bull;
        textSvg.append("tspan")
            .attr('dx', 0)
            .style('pointer-events', 'none')
            .style('font-size', '11px')
            .text('Tickets: ')
            .style('font-weight', 'bold')
        textSvg.append("tspan")
            .attr('dx', 0)
            .style('pointer-events', 'none')
            .style('font-weight', 'bold')
            .text(d3.format(',')(parseInt(value)));
    }
    mouseMove(container, pathElement, height, width) {
        d3.select(pathElement).style('cursor', 'pointer');
        var mousePosition = d3.mouse(pathElement);
        var x = mousePosition[0] + width / 2;
        //console.log("0 : " + mousePosition[0] + "x : " + x);
        var y = mousePosition[1] + height / 2;
        //console.log("1 : " + mousePosition[1] + "y : " + y);
        var text = d3.select(container).select("svg").select('.tooltip text');
        var bbox = text.node().getBBox();
        //console.log("bbox w : " + bbox.width);
        d3.select(container).select("svg").select('.tooltip rect')
            .attr("width", bbox.width + 15)
        //console.log("bbox h : " + bbox.height);
        if (x - bbox.width / 2 < 0) {
            x = bbox.width / 2;
        }
        else if (width - x - bbox.width / 2 < 0) {
            x = width - bbox.width / 2;
        }
        if (y - bbox.height / 2 < 0) {
            y = bbox.height * 2;
        }
        else if (height - y - bbox.height / 2 < 0) {
            y = height - bbox.height / 2;
        }
        return {
            'x': x, 'y': y
        };
        // when mouse moves         
        //console.log("mouse X: " + d3.event.layerX);
        //console.log("mouse Y: " + d3.event.layerY);
        //console.log(d3.select(pieChartContainer.nativeElement).select("svg").select('.tooltip').html());
        //d3.select(pieChartContainer.nativeElement).select("svg").select('.tooltip')//.style('top', (d3.event.layerY + 10) + 'px') // always 10px below the cursor
        //    .attr('transform', `translate(${d3.event.layerX-30}, ${d3.event.layerY-30})`)
        //.style('left', (d3.event.layerX + 10) + 'px'); // always 10px to the right of the mouse    
    }
    mouseOut(container, pathElement, opacity, i) {
        d3.select(container).select("svg").select('.tooltip').style('display', 'none');
        d3.select(container).select("svg").select('#trend_circle_' + i).style("display", 'none');
        d3.select(container).select("svg")
            .select(".tooltip").remove();
        d3.select(pathElement).selectAll('path')
            .style("opacity", opacity);
    }
    ConvertRGB2Hex(rgb) {
        rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        return (rgb && rgb.length === 4) ? "#" +
            ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
    }
}
